import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebase';
import WIcon from '../shared/WIcon';
import logo from '../../assets/logo_white.png';

const NAV_ITEMS = [
  { id: 'dashboard', to: '/company',          icon: 'dashboard', label: 'Dashboard', end: true },
  { id: 'employees', to: '/company/employees', icon: 'users',     label: 'Employees' },
  { id: 'tiers',     to: '/company/tiers',     icon: 'layers',    label: 'Benefit Tiers' },
  { id: 'settings',  to: '/company/settings',  icon: 'settings',  label: 'Settings' },
];

const CompanySidebar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try { await signOut(auth); } catch (_) { /* ignore */ }
    localStorage.removeItem('companyData');
    navigate('/company/login', { replace: true });
  };

  let companyName = 'Company Admin';
  try {
    const companyData = JSON.parse(localStorage.getItem('companyData') || '{}');
    if (companyData?.name) companyName = companyData.name;
  } catch (_) { /* ignore */ }

  const initials = companyName
    .split(' ')
    .map(s => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase() || 'CA';

  return (
    <aside className="loysta-sidebar">
      <div className="loysta-sidebar-header">
        <img src={logo} alt="Loysta" />
      </div>

      <div className="loysta-sidebar-portal-label">
        <span className="dot" />
        Company Admin
      </div>

      <nav className="loysta-sidebar-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `loysta-nav-link${isActive ? ' active' : ''}`}
          >
            <WIcon name={item.icon} size={17} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="loysta-sidebar-footer">
        <div className="loysta-sidebar-user">
          <div className="loysta-sidebar-user-avatar">{initials}</div>
          <div className="loysta-sidebar-user-info">
            <div className="loysta-sidebar-user-name">{companyName}</div>
            <div className="loysta-sidebar-user-sub">Company Admin</div>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="loysta-sidebar-logout-btn"
            title="Sign out"
          >
            <WIcon name="logout" size={15} />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CompanySidebar;
